import { createFileRoute, Link } from "@tanstack/react-router";
import { ShieldAlert } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/_authenticated/access-denied")({
  component: AccessDeniedPage,
});

function AccessDeniedPage() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
      <div className="flex size-14 items-center justify-center rounded-full bg-destructive/10 text-destructive">
        <ShieldAlert className="size-7" />
      </div>
      <h1 className="mt-6 text-2xl font-semibold tracking-tight">
        {t("access.title")}
      </h1>
      <p className="mt-2 max-w-md text-sm text-muted-foreground">
        {t("access.description")}
      </p>
      <Button asChild className="mt-6">
        <Link to="/dashboard">{t("access.back")}</Link>
      </Button>
    </div>
  );
}
